import React, { useState, useContext, useEffect, Fragment } from 'react';
import UserContext from '../../context/user/userContext';
import AuthContext from '../../context/auth/authContext';
import AlertContext from '../../context/alert/alertContext';

const UserForm = () => {
  const userContext = useContext(UserContext);
  const authContext = useContext(AuthContext);
  const alertContext = useContext(AlertContext);
  const { setAlert } = alertContext;

  const { addUser, current, clearCurrent, updateUser } = userContext;

  const loggedInUserRole = authContext.user.role;

  useEffect(() => {
    if (current != null) {
      setUser(current);
    } else {
      setUser({
        name: '',
        email: '',
        password: '',
        role: 'user'
      });
    }
  }, [userContext, current]);

  const [user, setUser] = useState({
    name: '',
    email: '',
    password: '',
    role: 'user'
  });

  const { name, email, password, role } = user;

  const onChange = e => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = e => {
    e.preventDefault();
    if (user.name !== '' || user.email !== '') {
      if (current === null) {
        addUser(user);
      } else {
        updateUser(user);
      }

      clearAll();
    } else {
      setAlert('Name and Email cannot be blank', 'danger');
    }
  };

  const clearAll = () => {
    clearCurrent();
  };

  return (
    <form onSubmit={onSubmit}>
      <h2 className='tex-primary'>{current ? 'Edit User' : 'Add User'}</h2>
      <input
        type='text'
        name='name'
        placeholder='Name'
        value={name}
        onChange={onChange}
      />
      <input
        type='email'
        name='email'
        placeholder='Email'
        value={email}
        onChange={onChange}
      />
      <input
        type='password'
        name='password'
        placeholder='Password'
        value={password || ''}
        onChange={onChange}
      />
      <h5>User Role</h5>
      <input
        type='radio'
        name='role'
        value='user'
        checked={role === 'user'}
        onChange={onChange}
      />
      User{' '}
      <input
        type='radio'
        name='role'
        value='apiClient'
        checked={role === 'apiClient'}
        onChange={onChange}
      />
      API Client{' '}
      {loggedInUserRole === 'admin' && (
        <Fragment>
          <input
            type='radio'
            name='role'
            value='admin'
            checked={role === 'admin'}
            onChange={onChange}
          />
          Admin
        </Fragment>
      )}
      <div>
        <input
          type='submit'
          value={current ? 'Update User' : 'Add User'}
          className='btn btn-primary btn-block'
        />
      </div>
      {current && (
        <div>
          <button className='btn btn-light btn-block' onClick={clearAll}>
            Clear
          </button>
        </div>
      )}
    </form>
  );
};

export default UserForm;
